import {UPDATE_CALENDAR} from '../actionTypes'


export default function (state = {}, action) {
    //console.log(action.type);
    //console.log(action.payload);
    switch (action.type) {
        case UPDATE_CALENDAR:
            return action.payload
    }

    return state;
}